import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TariComponent } from './tari.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from 'src/app/material.module';
import { AddTariComponent } from './add-tari/add-tari.component';
import { EditTariComponent } from './edit-tari/edit-tari.component';

@NgModule({
    declarations: [TariComponent, AddTariComponent, EditTariComponent],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        MaterialModule
    ],
    exports: [TariComponent]
})
export class TariModule { }
